module.exports = __webpack_public_path__ + "static/img/call-pass.b15856ac.png";